import React from "react";
import { etapasBasePorPrograma } from "../utils/itemResolvers.js";

const ETAPAS_FALLBACK = etapasBasePorPrograma[1];

export const Stepper = ({ etapaAtual = 1, etapas, tipoPrograma = 1 }) => {
  const etapasSeguras = (
    Array.isArray(etapas) && etapas.length > 0 ? etapas : ETAPAS_FALLBACK
  ).map((etapa) => {
    if (Number(tipoPrograma) === 0 && /aprendiz/i.test(etapa.nome)) {
      return { ...etapa, nome: etapa.nome.replace(/aprendiz/gi, "Estagiário") };
    }
    if (
      (Number(tipoPrograma) === 1 || Number(tipoPrograma) === 2) &&
      /estagi[aá]rio/i.test(etapa.nome)
    ) {
      return { ...etapa, nome: etapa.nome.replace(/estagi[aá]rio/gi, "Aprendiz") };
    }
    return etapa;
  });

  return (
    <div className="stepper-wrapper">
      <div className="stepper-linha-bg" />
      <div
        className="stepper-linha-progresso"
        style={{
          width: `${
            etapasSeguras.length > 1
              ? ((etapaAtual - 1) / (etapasSeguras.length - 1)) * 100
              : 0
          }%`,
        }}
      />
      <div className="stepper-bolinhas">
        {etapasSeguras.map((etapa, index) => {
          const numero = index + 1;
          const status =
            numero < etapaAtual
              ? "concluida"
              : numero === etapaAtual
                ? "andamento"
                : "pendente";

          return (
            <div className="stepper-etapa" key={etapa.id}>
              <div className={`stepper-bolinha stepper-bolinha-${status}`}>
                {status === "concluida" ? "✓" : numero}
              </div>
              <span className={`stepper-label stepper-label-${status}`}>
                {etapa.nome}
              </span>
            </div>
          );
        })}
      </div>
      <p className="stepper-status-texto">
        Etapa {etapaAtual} de {etapasSeguras.length} —{" "}
        <strong>{etapasSeguras[etapaAtual - 1]?.nome}</strong>
      </p>
    </div>
  );
};

export default Stepper;
